
<template>
    <v-container class="pa-5" fluid>
        <StopCardDialog
            :is-open="stopCardDialog"
            :stop-card-data="currentStopCard"
            @on-save="getStopCards"
            @on-close="hideStopCardDialog"
        />
        <CopiesCountDialog
            :is-open="copiesCountDialog"
            @close="closePrintStopCardDialog"
            @save="printStopCard"
        />
        <CloseStopCardDialog
            :is-open="showCloseStopCardDialogTrigger"
            @close="tryCloseStopCard"
        />
        <QualitativeNoteDialog
            :is-open="qualitativeNoteDialog"
            :qualitative-note-data="{}"
            :qualitative-note-id="null"
            :report-item-plate-data="qualitativeNoteReportItemData"
            :report-item-type-id="qualitativeNoteReportItemData.reportItemTypeId"
            :report-item-plate-id="qualitativeNoteReportItemData.id"
            :stop-card-id="currentStopCard.id"
            :production-process-id="currentStopCard.productionProcessId"
            @on-close="qualitativeNoteDialog = false"
        />
        <ComplaintsCreatedDialog
            :is-open="complaintsCreatedDialog"
            :stop-card="currentStopCard"
            :order="currentStopCard.RW_order"
            @close="complaintsCreatedDialog = false"
        />
        <page-title>Karty stop</page-title>
        <v-row align="center">
            <v-col cols="12" sm="4" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Dodaj kartę stop"
                    @click="showCreateStopCardDialog()"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj kartę stop
                </v-btn>
            </v-col>
            <v-col cols="12" sm="8" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="auto">
                            <v-menu
                                v-model="filtersMenu"
                                top
                                left
                                transition="scroll-x-reverse-transition"
                                :close-on-content-click="false"
                            >
                                <template #activator="{on}">
                                    <v-btn
                                        fab
                                        :color="hasFilters ? 'secondary' : 'grey darken-1'"
                                        elevation="1"
                                        small
                                        v-on="on"
                                    >
                                        <v-icon v-if="hasFilters" color="white">
                                            mdi-filter-plus
                                        </v-icon>
                                        <v-icon v-else color="white">
                                            mdi-filter-minus
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-container fluid>
                                        <v-row justify="end" dense>
                                            <v-col cols="auto">
                                                <v-btn icon small @click="toggleFiltersMenu()">
                                                    <v-icon color="grey darken-2">
                                                        mdi-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-autocomplete
                                                    v-model="filters.createdById"
                                                    :items="createdByUsers"
                                                    :filter="customUsersFilter"
                                                    :loading="usersSearchCreatedByLoading"
                                                    :search-input.sync="usersSearchCreatedBy"
                                                    label="Osoba wystawiająca"
                                                    class="v-text-field--placeholder-dark"
                                                    required
                                                    solo
                                                    hide-details
                                                    item-value="id"
                                                    no-data-text="Nie znaleziono"
                                                    clearable
                                                    @keyup.enter="changeFilter"
                                                    @input="changeFilter"
                                                    @click:clear="clearFilter('createdById')"
                                                >
                                                    <template slot="no-data">
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <template v-if="!usersSearchCreatedBy">
                                                                    Wpisz treść aby odnaleźć <strong>osobę wystawiającą</strong>.
                                                                </template>
                                                                <template v-else-if="usersSearchCreatedByLoading">
                                                                    Trwa wyszukiwanie...
                                                                </template>
                                                                <template v-else>
                                                                    Nie znaleziono
                                                                </template>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                    <template slot="selection" slot-scope="data">
                                                        <template v-if="data.item.firstName && data.item.lastName">
                                                            {{ data.item.firstName }} {{ data.item.lastName }}
                                                        </template>
                                                        <template v-else>
                                                            {{ data.item.username }}
                                                        </template>
                                                    </template>
                                                    <template slot="item" slot-scope="data">
                                                        <template v-if="data.item.firstName && data.item.lastName">
                                                            {{ data.item.firstName }} {{ data.item.lastName }}
                                                        </template>
                                                        <template v-else>
                                                            {{ data.item.username }}
                                                        </template>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-select
                                                    v-model="filters.statusId"
                                                    label="Status"
                                                    :items="statuses"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Brak danych..."
                                                    solo
                                                    clearable
                                                    hide-details
                                                    single-line
                                                    @click:clear="clearFilter('statusId')"
                                                    @change="changeFilter()"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-select
                                                    v-model="filters.productionDepartmentId"
                                                    :items="productionDepartments"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Dział odpowiedzialny"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-text-field
                                                    v-model="filters.search"
                                                    append-icon="mdi-magnify"
                                                    label="Szukaj..."
                                                    single-line
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @keyup.enter="changeFilter"
                                                    @click:append="changeFilter"
                                                    @click:clear="clearFilter('search')"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6" lg="6">
                                                <v-select
                                                    v-model="filters.productionProcessId"
                                                    :items="productionProcesses"
                                                    label="Proces"
                                                    item-value="id"
                                                    item-text="name"
                                                    chips
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="6" lg="6">
                                                <v-select
                                                    v-model="filters.errorId"
                                                    :items="errors"
                                                    label="Kod błędu"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row justify="end">
                                            <v-col cols="12" md="6" lg="6">
                                                <v-select
                                                    v-model="filters.productTypeId"
                                                    :items="productTypes"
                                                    item-text="name"
                                                    item-value="id"
                                                    label="Produkt"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-menu
                                                    v-model="menuFrom"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.createdAt__gte"
                                                            label="Od:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('createdAt__gte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.createdAt__gte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuFrom = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-menu
                                                    v-model="menuTo"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.createdAt__lte"
                                                            label="Do:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('createdAt__lte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.createdAt__lte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuTo = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="generateReportLoading"
                    @click="generateStopCardsReport"
                >
                    <v-icon
                        v-if="!generateReportLoading"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="stopCards"
                        :loading="stopCardsLoading || ordersProductionNumbersLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="stopCardsData"
                        @pagination="updatePagination"
                    >
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.jobNumber="{item}">
                            {{ parseEmptyValue(item.jobNumber) }}
                        </template>
                        <template #item.orderNumber="{item}">
                            {{ parseEmptyValue(item.orderNumber) }}
                        </template>
                        <template #item.productType="{item}">
                            {{ item.productType.name }}
                        </template>
                        <template #item.error="{item}">
                            {{ item.error.name }}
                        </template>
                        <template #item.productionDepartment="{item}">
                            {{ item.productionDepartment.name }}
                        </template>
                        <template #item.productionProcess="{item}">
                            {{ item.productionProcess.name }}
                        </template>
                        <template #item.createdBy="{item}">
                            <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                            </template>
                            <template v-else>
                                {{ item.createdBy.username }}
                            </template>
                        </template>
                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Generuj karty stop"
                                            v-on="on"
                                            @click="tryPrintStopCard(item.id)"
                                        >
                                            <v-icon color="teal">
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Generuj karty stop</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" max-width="500px" left>
                                    <template #activator="{on}">
                                        <v-icon
                                            color="blue"
                                            class="mx-1"
                                            :disabled="!item.description"
                                            v-on="on"
                                        >
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>{{ item.description }}</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Zamknij"
                                            :disabled="item.statusId === 20"
                                            v-on="on"
                                            @click="showCloseStopCardDialog(item)"
                                        >
                                            <v-icon color="red">
                                                mdi-close-circle
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Zamknij</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Otwórz"
                                            v-on="on"
                                            @click="showStopCardDialog(item.id)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import StopCardDialog from './StopCardDialog'
import CopiesCountDialog from './CopiesCountDialog'
import CloseStopCardDialog from './CloseStopCardDialog'
import ComplaintsCreatedDialog from './ComplaintsCreatedDialog'
import QualitativeNoteDialog from '@/views/Complaints/QualitativeNotes/QualitativeNoteDialog'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'
import { addSentryBreadcrumb } from '@/utils/errorHandler'
import { openPdfFile } from '@/utils/pdfHandler'
import { EventBus } from '@/utils/eventBus'

let searchTimer

export default {
    name: 'StopCards',
    components: {
        PageTitle,
        StopCardDialog,
        CopiesCountDialog,
        CloseStopCardDialog,
        QualitativeNoteDialog,
        ComplaintsCreatedDialog,
    },
    mixins: [
        filters,
        customFilters,
        pagination,
        dateFormatter,
        parse,
        tooltipDelay
    ],
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('complaints/clearStopCardsFilters')
        next()
    },
    data() {
        return {
            filtersMenu: false,
            menuFrom: false,
            menuTo: false,
            createdByUsers: [],
            stopCardsLoading: false,
            usersSearchCreatedBy: null,
            usersSearchCreatedByLoading: false,
            hasFilters: false,
            generateReportLoading: false,
            currentStopCard: {},
            stopCardDialog: false,
            copiesCountDialog: false,
            showCloseStopCardDialogTrigger: false,
            ordersProductionNumbersLoading: false,
            complaintsCreatedDialog: false,
            qualitativeNoteDialog: false,
            qualitativeNoteReportItemData: {},
            headers: [
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false
                },
                {
                    text: 'Data wystawienia',
                    value: 'createdAt',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Numer zlecenia',
                    value: 'jobNumber',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Numer zamówienia',
                    value: 'orderNumber',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Produkt',
                    value: 'productType',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Kod błędu',
                    value: 'error',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Dział odpowiedzialny',
                    value: 'productionDepartment',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Proces',
                    value: 'productionProcess',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Osoba wystawiajaca',
                    value: 'createdBy',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        userEmail() {
            return this.$store.state.user.userEmail
        },
        stopCards() {
            return this.$store.state.complaints.stopCards.stopCards
        },
        errors() {
            return this.$store.state.complaints.stopCards.errors
        },
        statuses() {
            return this.$store.state.complaints.stopCards.statuses
        },
        productionDepartments() {
            return this.$store.state.administration.users.productionDepartments
        },
        productionProcesses() {
            return this.$store.state.configurations.productProductionProcesses.productionProcesses
        },
        productTypes() {
            return this.$store.state.configurations.products.products
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    watch: {
        usersSearchCreatedBy(value = null) {
            if (value === null) return

            this.usersSearchCreatedByLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsersCreatedBy(value)
                } else {
                    this.usersSearchCreatedByLoading = false
                    this.createdByUsers = []
                }
            }, 500)
        }
    },
    mounted() {
        this.getStopCards()
        Promise.all([
            this.$store.dispatch('complaints/getCodes'),
            this.$store.dispatch('complaints/getStopCardErrors'),
            this.$store.dispatch('complaints/getStopCardStatuses'),
            this.$store.dispatch('complaints/getWaysOfClosing'),
            this.$store.dispatch('administration/getStopCardsProductionDepartments'),
            this.$store.dispatch('configurations/getProductionProcesses', {paginate: '', query: ''}),
            this.$store.dispatch('configurations/getProducts', { paginate: '', query: '' })
        ])
            .catch(error => {
                errorHandler(error)
            })
    },
    created() {
        EventBus.$on('qualitativeNoteCreated', this.closeStopCard)
        EventBus.$on('complaintCreated', this.closeStopCard)
        this.checkFilters()
        document.addEventListener('keydown', this.QRtoJSON)
    },
    destroyed() {
        document.removeEventListener('keydown', this.QRtoJSON)
    },
    methods: {
        showCreateStopCardDialog() {
            this.stopCardDialog = true
        },
        showStopCardDialog(id) {
            this.$store.dispatch('complaints/getStopCard', id)
                .then(response => {
                    this.currentStopCard = response.data
                    this.stopCardDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        hideStopCardDialog() {
            this.stopCardDialog = false
            this.currentStopCard = {}
        },
        toggleFiltersMenu() {
            this.filtersMenu = !this.filtersMenu
        },
        searchUsersCreatedBy(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.createdByUsers = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchCreatedByLoading = false
                })
        },
        getStopCards() {
            this.stopCardsLoading = true
            this.$store.dispatch('complaints/getStopCards', {
                paginate: this.paginate(),
                query: this.filterQuery,
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.stopCardsLoading = false
                })
        },
        showCloseStopCardDialog(stopCard) {
            this.showCloseStopCardDialogTrigger = true
            this.currentStopCard = stopCard
        },
        tryCloseStopCard(value) {
            this.showCloseStopCardDialogTrigger = false

            if (value === null) {
                this.currentStopCard = {}

                return
            }

            switch (value) {
                case 'UJ':
                    this.tryCreateQualitativeNote()
                    break
                case 'RW':
                    this.tryCreateComplaint()
                    break
            }
        },
        closeStopCard() {
            this.$store.dispatch('complaints/getStopCard', this.currentStopCard.id)
                .then(response => {
                    this.currentStopCard = {
                        ...response.data,
                        statusId: 20, // Zamknięta
                        wayOfClosingId: this.currentStopCard.wayOfClosingId,
                    }
                    this.$store.dispatch('complaints/updateStopCard', this.currentStopCard)
                        .then(() => {
                            this.getStopCards()
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.currentStopCard = {}
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        tryCreateQualitativeNote() {
            this.currentStopCard.wayOfClosingId = 20 // UJ automatycznie

            this.$store.dispatch('complaints/getReportItemPlates', {
                paginate: '',
                query: `?reportItemPrimaryNumber=${this.currentStopCard.jobNumber || this.currentStopCard.orderNumber}`
            })
                .then(({data}) => {
                    if (data.count === 0) {
                        this.$store.dispatch('showNotification', {
                            type: 'error',
                            message: 'Brak uwag jakościowych dla karty stop'
                        })

                        return
                    }

                    const reportItem = data.results.filter(item => item.plateNumber === +this.currentStopCard.plateNumber)

                    if (reportItem.length === 0) {
                        this.$store.dispatch('showNotification', {
                            type: 'error',
                            message: 'Pobranie zleceń oraz zamówień nie powiodło się.'
                        })

                        return
                    }
                    this.qualitativeNoteReportItemData = reportItem[0]
                    this.qualitativeNoteDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        async tryCreateComplaint() {
            this.currentStopCard.wayOfClosingId = 30 // RW - automatyczne

            let order

            if (this.currentStopCard.orderNumber) {
                this.ordersProductionNumbersLoading = true
                order = await this.findOrder()
            }

            if (order) {
                this.currentStopCard.RW_order = `${order.order_full_number_cfprint} - ${order.produkt_nazwa}`
            }
            this.complaintsCreatedDialog = true
        },
        checkFilters() {
            this.hasFilters = !Object.values(this.filters).every(item => item == null || item.length == 0)
        },
        changeFilter() {
            this.resetPagination()
            this.checkFilters()
            this.getStopCards()
        },
        generateStopCardsReport() {
            this.generateReportLoading = true
            this.$store.dispatch('complaints/generateStopCardsReport', {
                query: this.filterQuery,
                userEmail: this.userEmail
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.generateReportLoading = false
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getStopCards()
            }
            this.clearPaginationPending()
        },
        tryPrintStopCard(cardId) {
            this.copiesCountDialog = true
            this.currentStopCard = { stopCardId: cardId }
        },
        printStopCard(copiesCount) {
            this.currentStopCard.copiesCount = copiesCount

            this.$store.dispatch('complaints/printStopCard', this.currentStopCard)
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closePrintStopCardDialog()
                })
        },
        closePrintStopCardDialog() {
            this.copiesCountDialog = false
            this.currentStopCard = {}
        },

        async findOrder() {
            return await this.$store.dispatch('complaints/findOrder', {
                query: this.currentStopCard.orderNumber,
            })
                .then(({data}) => {
                    return data.count ? data.results[0] : null
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.ordersProductionNumbersLoading = false
                })
        }

    },
}
</script>
